/**
 * Builds a versioned URL by fetching the ETag from the server.
 * This is used for cache busting - when the file changes, the ETag changes,
 * resulting in a different URL that bypasses browser/CDN cache.
 *
 * @param baseUrl - The base URL of the resource
 * @returns The URL with a version query parameter based on ETag (or timestamp as fallback)
 */
export async function buildVersionedUrl(baseUrl: string): Promise<string> {
	try {
		const headResponse = await fetch(baseUrl, { method: 'HEAD' })
		const etag = headResponse.headers.get('etag')

		if (etag) {
			return `${baseUrl}?v=${encodeURIComponent(etag)}`
		}
	} catch (error) {
		console.error('Failed to fetch resource ETag:', error)
	}

	return `${baseUrl}?v=${Date.now()}`
}

export default buildVersionedUrl
